'use strict';

var angular = require('angular');
var WizardStepDirective = function WizardStepDirective(wizardHandler) {
  return {
    restrict: 'E',
    replace: true,
    transclude: {
      'transitionButtons': '?rmWizardTransitionButtons'
    },
    template: require('../templates/wizard-step.html'),
    scope: {
      header: '@',
      subHeader: '@',
      backButton: '@',
      nextButton: '@',
      cancelButton: '@',
      customNextAction: '&?',
      triggerCustomAction: '=?',
      stepsButtonsDisabled: '=?',
      isFirstStep: '=?',
      isNextDisabled: '=?',
      backButtonPermissionFor: '@?',
      backButtonExpectPrivilege: '@?',
      nextButtonPermissionFor: '@?',
      nextButtonExpectPrivilege: '@?',
      isSave: '@?'
    },
    link: function link(scope, element) {
      if (scope.isFirstStep) {
        scope.backButton = '';
      }
      if (scope.backButton === undefined) {
        scope.backButton = 'Back';
      }
      if (scope.nextButton === undefined) {
        scope.nextButton = 'Next';
      }
      scope.isBackButtonSecure = function () {
        return !!(scope.backButton && scope.backButtonPermissionFor && scope.backButton !== 'Back');
      };
      scope.isNextButtonSecure = function () {
        return !!(scope.nextButton && scope.nextButtonPermissionFor && scope.nextButton !== 'Next');
      };
      var wrapper = element.find('.content');
      wrapper.bind('scroll', function () {
        var dropdowns = angular.element('.rm-step-sponsorship .input-group.dropdown.open');
        if (dropdowns.length) {
          scope.$broadcast('hide.sponsor.dropdown', dropdowns);
        }
      });
      scope.nextAction = function () {
        if (scope.triggerCustomAction) {
          scope.customNextAction();
        } else {
          wizardHandler.wizard().next();
        }
      };
      scope.backToScheduleChange = function () {
        scope.$emit('schedule-change:exitWizard');
      };
    }
  };
};
WizardStepDirective.$inject = ['WizardHandler'];
module.exports = WizardStepDirective;